'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('submit', '.auth-box--unsubscribe__form', function () {
    const $form = $(this);
    const email = $form.find('#unsubscribe_email').val();
    const $submit = $form.find('button[type=submit]');

    if (!email) {
      $('#unsubscribe_email').focus();
      return false;
    }

    $submit.addClass('button-loading').prop('disabled', true);
  });
});
